import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { ghcolors } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface MarkdownWithDiffProps {
    children: string;
}

/**
 * Markdown renderer with syntax highlighting support for diff blocks.
 * Uses react-syntax-highlighter with Prism for color-coded git-style diffs.
 */
const MarkdownWithDiff: React.FC<MarkdownWithDiffProps> = ({ children }) => {
    return (
        <ReactMarkdown
            components={{
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                code({ inline, className: codeClassName, children: codeChildren, ...props }: any) {
                    const match = /language-(\w+)/.exec(codeClassName || '');
                    const language = match ? match[1] : '';

                    if (!inline && language === 'diff') {
                        // Use syntax highlighter for diff blocks
                        return (
                            <SyntaxHighlighter
                                style={ghcolors}
                                language="diff"
                                PreTag="div"
                                {...props}
                            >
                                {String(codeChildren).replace(/\n$/, '')}
                            </SyntaxHighlighter>
                        );
                    }

                    // For inline code or non-diff blocks, use default rendering
                    return (
                        <code className={codeClassName} {...props}>
                            {codeChildren}
                        </code>
                    );
                },
            }}
        >
            {children}
        </ReactMarkdown>
    );
};

export default MarkdownWithDiff;
